"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: ", ";\n  height: ", ";\n  box-sizing: border-box;\n  & > svg {\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconBase = void 0;

var _stylitas = require("@creditas/stylitas");

var iconBase = function iconBase(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '48px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '48px' : _ref$height;
  return (0, _stylitas.css)(_templateObject(), width, height);
};

exports.iconBase = iconBase;